import type { DropdownMenuItem } from '@nuxt/ui';
import type { ResolvedMonospaceCollection } from '#layers/data-model/public';
import { useI18n } from 'vue-i18n';
import { useRouter } from '#app/composables/router';
import { resolveCollectionListingRoute } from '#layers/workspace/composables/use-collection-routes';

export function useCollectionNavigationActions() {
	const { t } = useI18n();
	const router = useRouter();

	return {
		getViewContentAction,
	};

	function getViewContentAction(collection: ResolvedMonospaceCollection): DropdownMenuItem & { id: string } {
		const route = resolveCollectionListingRoute(collection);

		return {
			id: `${collection.id}-view-content`,
			label: t('pages.data_model.view_content'),
			icon: 'lucide:arrow-up-right',
			disabled: !route,
			onSelect: () => {
				if (route) {
					router.push(route);
				}
			},
		};
	}
}
